<app-workflow-step-layout [readOnly]="readOnly">
  <div info>
    <ng-container *ngIf="!readOnly; else readOnlyBatches">
      <ng-container *ngFor="let plate of workflowStep.plates; let i = index">
        <hr *ngIf="i > 0">
        <app-adding-controls-batch-selector
          [name]="workflowStep | workflowName:plate"
          [(batch)]="plate.positiveProbe"
          [positiveControl]="plate.positions[0]"
          [readOnly]="readOnly || (selectedPlate && selectedPlate.id != plate.id)"
          (batchChange)="validateStep()">
        </app-adding-controls-batch-selector>
      </ng-container>
    </ng-container>
  </div>

  <ng-container plate>
    <app-plate-view
      [plateMode]="PlateMode.POSITION_EXIST"
      [workflowInstance]="workflowInstance"
      [plates]="workflowStep?.plates"
      (onPlateSelected)="selectedPlate = $event">
    </app-plate-view>
  </ng-container>
</app-workflow-step-layout>

<ng-template #readOnlyBatches>
  <h3>Verwendete Chargen</h3>
  <div class="batch-readonly-view">
    <div *ngFor="let plate of workflowStep.plates" class="batch-read-only-item">
      <div class="batch-info">
        Platte {{ getFirstCharacter(plate.suffix) }}:
      </div>
      <div class="batch-number">
        <b>{{ plate?.positiveProbe?.batchNumber }}</b>
      </div>
    </div>
  </div>
</ng-template>
